import React from "react";
import shortid from "shortid";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";
import * as actionTypes from "../../../store/actions/actionTypes";
import RatingStar from "../../Common/RatingStar";
import { composeArrayForRatings } from "../CommonMethods";
import lodash from "lodash";
import windowSize from "react-window-size";
import "./filter.css";
import Loader from "../Loader";
import { openAPI } from "../../../config";

class VendorFilter extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      size: [],
      ind: [],
      sort: "",
      product: [],
      sizeName: [],
      indName: [],
      productName: [],
      checkedindObj: [],
      checkedsizeObj: [],
      checkedproductObj: [],
      toggleViewDD: false,
      toggleCompanySizeDD: false,
      toggleIndustryDD: false,
      toggleProductDD: false,
      selectedView: 15,
      captionCompany: "Company Size",
      captionIndustry: "Industry",
      captionSortBy: "Sort By",
      indSearchResult: [],
      indSearchKeyword: "",
      indSearch: [],
      smallScreenFilter: true,
      isLoader: false,
      searchText: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.applyIndustryFilter = this.applyIndustryFilter.bind(this);
    this.toggleLoader = this.toggleLoader.bind(this);
    this.getIsDisplayed = this.getIsDisplayed.bind(this);
    this.getIsDisplayedInverse = this.getIsDisplayedInverse.bind(this);
    this.getDisplayOnToggle = this.getDisplayOnToggle.bind(this);
    this.isIndexAvailable = this.isIndexAvailable.bind(this);
    this.getRatingStar = this.getRatingStar.bind(this);
    this.getRatingText = this.getRatingText.bind(this);
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    this.setState({ indSearch: this.props.industryOptions });
    //this.props.resetFilterData();
    //this.applyFilter();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate() {
    if (
      this.props.windowWidth > 575 &&
      !this.state.smallScreenFilter &&
      this._isMounted
    ) {
      this.setState({ smallScreenFilter: true });
    }
    if (
      this.state.indSearch.length === 0 &&
      this.props.industryOptions.length > 0
    ) {
      this.setState({ indSearch: this.props.industryOptions });
    }
  }

  toggleLoader = () => {
    if (this._isMounted) {
      this.setState((prevState) => {
        return {
          isLoader: !prevState.isLoader,
        };
      });
    }
  };

  handleChange = (name, object) => (event) => {
    event.persist();
    let value = event.target.value;
    const nameKey = `${name}Name`;
    const checkedObj = `checked${name}Obj`;
    if (event.target.checked && this._isMounted) {
      this.setState(
        (prevState) => {
          if (name !== "sort") {
            value = Number(value);
            if (prevState[name].indexOf(value) !== -1) {
              return {
                [name]: prevState[name],
                nameKey: prevState[nameKey],
              };
            } else {
              const updatedValue = [...prevState[name], value];
              const updatedName = [
                ...prevState[nameKey],
                "optionElement.value",
              ];
              console.log("HandleChange", name, nameKey, checkedObj);
              return {
                [name]: updatedValue,
                [nameKey]: updatedName,
                [checkedObj]: [...this.state[checkedObj], object],
              };
            }
          } else {
            const index = event.target.selectedIndex;
            const optionElement = event.target.childNodes[index];
            const option = optionElement.getAttribute("rel");
            return {
              [name]: option,
              [nameKey]: optionElement.value,
            };
          }
        },
        () => {
          if (name === "sort") {
            this.applyFilter(event);
          }
        }
      );
    } else {
      if (this._isMounted) {
        this.setState(
          (prevState) => {
            if (name !== "sort") {
              value = Number(value);
              const tempArr = [...prevState[name]];
              tempArr.splice(tempArr.indexOf(value), 1);
              let removedObject = prevState[checkedObj].filter(
                (obj) => obj.value !== value
              );
              return { [name]: tempArr, [checkedObj]: removedObject };
            } else if (name === "sort") {
              const index = event.target.selectedIndex;
              const optionElement = event.target.childNodes[index];
              const option = optionElement.getAttribute("rel");
              return {
                [name]: option,
                [nameKey]: optionElement.value,
              };
            }
          },
          () => {
            if (name === "sort") {
              this.applyFilter(event);
            }
          }
        );
      }
    }
  };

  applyIndustryFilter = (keyword) => {
    const regex = new RegExp(keyword, "gi");
    this.props.industryOptions.map((industry) => ({
      ...industry,
      hasKeyword: regex.test(industry.text),
      lowercase: industry.text.toLowerCase(),
    }));
  };

  getURLToPush = () => {
    const regex = new RegExp(/&*$/, "gi");
    let checkAndRemovePageNumberFromSearch = queryString.parse(
      this.props.location.search
        .replace(/&+/g, "&")
        .replace(/&+$/, "")
        .replace(/\?&/, "?"),
      {
        arrayFormat: "comma",
      }
    );
    delete checkAndRemovePageNumberFromSearch.p;
    let tempUrl = `${this.props.location.pathname}?${queryString.stringify(
      checkAndRemovePageNumberFromSearch,
      {
        arrayFormat: "comma",
      }
    )}`;

    if (!!this.props.location.search) {
      checkAndRemovePageNumberFromSearch.ind = this.state.ind;
      checkAndRemovePageNumberFromSearch.size = this.state.size;
      checkAndRemovePageNumberFromSearch.sort = this.state.sort;
      if (!!this.state.searchText) {
        checkAndRemovePageNumberFromSearch.q = this.state.searchText;
      }
      tempUrl = `${this.props.location.pathname}?${queryString.stringify(
        checkAndRemovePageNumberFromSearch,
        {
          arrayFormat: "comma",
        }
      )}`;
    } else {
      //Adding condition to not push all blank query params
      if (
        !!this.state.sort ||
        !!this.state.ind.length ||
        !!this.state.size.length
      ) {
        let paramObj = {
          size: this.state.size,
          ind: this.state.ind,
          sort: this.state.sort,
        };
        tempUrl = `${tempUrl}?${queryString.stringify(paramObj, {
          arrayFormat: "comma",
        })}`;
      }
    }

    //Need to check of there are duplicate filter key
    if (tempUrl.split("?").length > 1) {
      let qParams = queryString.parse(tempUrl.split("?")[1], {
        arrayFormat: "comma",
      });
      if (!!qParams.view) {
        qParams.view = this.props.paginationInfo.per_page;
      }
      this.props.history.push(
        `${this.props.location.pathname}?${queryString.stringify(qParams, {
          arrayFormat: "comma",
        })}`
      );
    } else {
      this.props.history.push(tempUrl);
    }
  };

  //https://mandeep.featuredcustomers.com/api/v1?size=&ind=&sort=
  applyFilter = (e) => {
    if (!!e) {
      e.preventDefault();
      e.persist();
    }

    this.toggleLoader();
    const currentFilter = Object.assign(
      {},
      {
        size: this.state.size,
        ind: this.state.ind,
        sort: this.state.sort,
        prod: this.state.product,
        q: this.state.searchText,
        p: 1, //hardcoding 1 to reset query parameter from any other page
      }
    );
    const keys = Object.keys(currentFilter);
    const composedString = keys.map((key) => {
      if (Boolean(currentFilter[key].length)) {
        if (typeof currentFilter[key] === "string") {
          return `${key}=${currentFilter[key]}`;
        } else {
          return `${key}=${currentFilter[key].join(",")}`;
        }
      } else {
        return `${key}=`;
      }
    });

    // this.props.setFilterData(
    //   `sort=${this.state.sort}&ind=${this.state.ind.join(
    //     ","
    //   )}&size=${this.state.size.join(",")}&view=${this.state.selectedView}`
    // );

    this.props.setFilterData(
      `${queryString.stringify(currentFilter, {
        arrayFormat: "comma",
      })}`
    );

    const allURLPattern = new RegExp("/all\\?");
    let tempURL = `${process.env.REACT_APP_API_URL}${
      this.props.match.url
    }?${composedString.join("&")}`;
    let fetchURL = "";
    if (allURLPattern.test(tempURL)) {
      fetchURL = tempURL.replace("/all$", "");
      fetchURL = `${fetchURL}&view=all`;
    } else {
      fetchURL = `${tempURL}&view=${this.state.selectedView}`;
    }

    openAPI
      .get(fetchURL, {
        withCredentials: true,
      })
      .then((response) => {
        const splittedPath = this.props.match.url.split("/");
        this.toggleLoader();
        switch (splittedPath[splittedPath.length - 1]) {
          case "testimonials":
            this.props.setTestimonialFilterTrue();
            this.props.saveVendorTestimonialsData(response.data);
            this.getURLToPush();
            break;
          case "case-studies":
            this.props.setCaseStudiesFilterTrue();
            this.props.saveVendorCaseStudiesData(response.data);
            this.getURLToPush();
            break;
          case "customer-videos":
            this.props.setVideosFilterTrue();
            this.props.saveVendorVideoData(response.data);
            this.getURLToPush();
            break;
          default:
            break;
        }
      });
  };

  resetFilter = (event) => {
    event.preventDefault();
    console.log("ResetFilter Called !!");
    this.toggleLoader();
    if (this._isMounted) {
      this.setState(
        (prevState) => {
          return {
            size: [],
            ind: [],
            product: [],
            checkedindObj: [],
            checkedsizeObj: [],
            checkedproductObj: [],
            sort: "",
            toggleCompanySizeDD: false,
            toggleIndustryDD: false,
            toggleProductDD: false,
            captionCompany: "Company Size",
            captionIndustry: "Industry",
            captionSortBy: "Sort By",
            searchText: "",
          };
        },
        () => {
          const allURLPattern = new RegExp("/all$");
          let tempURL = `${process.env.REACT_APP_API_URL}${this.props.match.url}`;
          let fetchURL = "";
          if (allURLPattern.test(tempURL)) {
            fetchURL = tempURL.replace(allURLPattern, "");
            fetchURL = `${fetchURL}?view=all`;
          } else {
            fetchURL = tempURL;
          }
          openAPI
            .get(fetchURL, {
              withCredentials: true,
            })
            .then((response) => {
              const splittedPath = this.props.match.url.split("/");
              this.toggleLoader();

              switch (splittedPath[splittedPath.length - 1]) {
                case "testimonials":
                  this.props.saveVendorTestimonialsData(response.data);
                  this.props.history.push(this.props.location.pathname);
                  break;
                case "case-studies":
                  this.props.saveVendorCaseStudiesData(response.data);
                  this.props.history.push(this.props.location.pathname);
                  break;
                case "customer-videos":
                  this.props.saveVendorVideoData(response.data);
                  this.props.history.push(this.props.location.pathname);
                  break;
                default:
                  break;
              }
            });
        }
      );
    }
  };

  getIsDisplayed = () => {
    return this.props.windowWidth <= 575 && this.state.smallScreenFilter
      ? { display: "none" }
      : { display: "block" };
  };

  getIsDisplayedInverse = () => {
    return this.props.windowWidth <= 575 && this.state.smallScreenFilter
      ? { display: "block" }
      : { display: "none" };
  };

  getDisplayOnToggle = (toggleKey) => {
    return this.state[toggleKey] ? { display: "block" } : { display: "none" };
  };

  isIndexAvailable = (lookInto, lookFor) => {
    return this.state[lookInto].indexOf(lookFor) !== -1 ? true : false;
  };

  getRatingText = (name, pathInfo) => {
    if (pathInfo.path.includes("/vendor/:id/testimonials")) {
      let testimonialsRating = lodash.filter(this.props.vendorProfile.rating, {
        rating_of: "testimonials",
      })[0];
      if (!!testimonialsRating) {
        return this.ratingJSX(
          name,
          testimonialsRating.aggregate_score,
          testimonialsRating.rated_by_user_count,
          "Testimonials"
        );
      } else {
        return null;
      }
    }
    if (pathInfo.path.includes("/vendor/:id/case-studies")) {
      let caseStudiesRating = lodash.filter(this.props.vendorProfile.rating, {
        rating_of: "case_studies",
      })[0];
      if (!!caseStudiesRating) {
        return this.ratingJSX(
          name,
          caseStudiesRating.aggregate_score,
          caseStudiesRating.rated_by_user_count,
          "Case Studies"
        );
      } else {
        return null;
      }
    }
    if (pathInfo.path.includes("/vendor/:id/customer-videos")) {
      let videosRating = lodash.filter(this.props.vendorProfile.rating, {
        rating_of: "videos",
      })[0];
      if (!!videosRating) {
        return this.ratingJSX(
          name,
          videosRating.aggregate_score,
          videosRating.rated_by_user_count,
          "Videos"
        );
      } else {
        return null;
      }
    }
  };

  ratingJSX = (name, rating, ratedByUserCount, refType) => {
    return (
      <div className="starRating">
        <span className="txt">{`Overall ${refType} Rating`}</span>
        <div className="rating">
          <span className="clsTxt">{rating}</span>
          <RatingStar inline starCount={composeArrayForRatings(rating)} />
        </div>
        <p>
          {`${name} ${refType.toLowerCase()} have an aggregate content usefulness score of
            ${rating}/5 based on ${ratedByUserCount} user ratings.`}
          {/* {!!this.props.vendorCommon &&
            !!this.props.vendorCommon.name &&
            !!this.props.match &&
            this.props.match.path &&
            this.getRatingText(this.props.vendorCommon.name, this.props.match)} */}
        </p>
      </div>
    );
  };

  getRatingStar = () => {
    return this.props.vendorCommon &&
      this.props.vendorCommon.rating &&
      this.props.vendorCommon.rating.aggregate_score ? (
      <div className="starRating">
        <span className="txt">Overall Customer Ref. Rating</span>

        <div className="rating">
          <span className="clsTxt">
            {this.props.vendorCommon.rating.aggregate_score}
          </span>
          <RatingStar
            inline
            starCount={composeArrayForRatings(
              this.props.vendorCommon.rating.aggregate_score
            )}
          />
        </div>
        <p>
          {!!this.props.vendorCommon &&
            !!this.props.vendorCommon.name &&
            !!this.props.match &&
            this.props.match.path &&
            this.getRatingText(this.props.vendorCommon.name, this.props.match)}
        </p>
      </div>
    ) : null;
  };

  removeCriteriaFromFilter = (name, object) => {
    const nameKey = `${name}Name`;
    const checkedObj = `checked${name}Obj`;
    this.setState((prevState) => {
      let value = Number(object.value);
      const tempArr = [...prevState[name]];
      const tempArrNameKey = [...prevState[nameKey]];
      let idxOf = tempArr.indexOf(value);
      tempArr.splice(idxOf, 1);
      tempArrNameKey.splice(idxOf, 1);
      let removedObject = prevState[checkedObj].filter(
        (obj) => obj.value !== value
      );
      return {
        [name]: tempArr,
        [nameKey]: tempArrNameKey,
        [checkedObj]: removedObject,
      };
    });
  };

  getTestimonialViewCount = (reviewLength) => {
    if (reviewLength > 0 && reviewLength < 16) {
      return 15;
    }
    if (reviewLength > 16 && reviewLength < 31) {
      return 30;
    }
    if (reviewLength > 30) {
      return "all";
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="left">
          <div className="choose_industry">
            <div
              className="searchBlock"
              onClick={(e) => {
                e.preventDefault();
                this.setState((prev) => ({
                  toggleIndustryDD: !prev.toggleIndustryDD,
                  toggleCompanySizeDD: false,
                  toggleViewDD: false,
                  toggleProductDD: false,
                }));
              }}
            >
              <span className="txt">{this.state.captionIndustry}</span>
            </div>
            <div
              className="chooseIndustryBlock"
              style={
                !!this.state.toggleIndustryDD
                  ? { display: "block" }
                  : { display: "none" }
              }
              onMouseLeave={(e) => {
                if (this._isMounted) {
                  this.setState((prevState) => {
                    return {
                      toggleIndustryDD: !prevState.toggleIndustryDD,
                    };
                  });
                }
              }}
            >
              <div className="searchBox">
                <input
                  type="text"
                  name=""
                  placeholder="Search"
                  onChange={(e) => {
                    e.preventDefault();
                    e.persist();
                    if (this._isMounted) {
                      this.setState({ indSearchKeyword: e.target.value });
                    }
                  }}
                />
                <span
                  className="searchIcon"
                  onClick={(e) => {
                    e.preventDefault();
                    this.applyIndustryFilter(this.state.indSearchKeyword);
                  }}
                ></span>
              </div>
              <div className="checkbox_control_group">
                {!this.state.indSearchKeyword
                  ? [...this.state.indSearch].map((option) => {
                      return (
                        <label
                          key={`label_ind_${option.value}`}
                          className="checkbox_control control--checkbox"
                        >
                          {option.text}
                          <input
                            type="checkbox"
                            value={option.value}
                            name="small-business"
                            id={`chk_input_ind_${option.value}`}
                            onChange={this.handleChange("ind", option)}
                            checked={this.isIndexAvailable("ind", option.value)}
                          />
                          <div className="checkboxControlIndicator"></div>
                        </label>
                      );
                    })
                  : lodash
                      .filter(this.state.indSearch, (obj) => {
                        const regex = RegExp(this.state.indSearchKeyword, "gi");
                        obj["isMatched"] = regex.test(obj.text);
                        return obj.isMatched;
                      })
                      .map((option) => {
                        return (
                          <label
                            key={`label_ind_${option.value}`}
                            className="checkbox_control control--checkbox"
                          >
                            {option.text}
                            <input
                              type="checkbox"
                              value={option.value}
                              name="small-business"
                              id={`chk_input_ind_${option.value}`}
                              onChange={this.handleChange("ind")}
                              checked={this.isIndexAvailable(
                                "ind",
                                option.value
                              )}
                            />
                            <div className="checkboxControlIndicator"></div>
                          </label>
                        );
                      })}
              </div>
            </div>
            <div
              className="selected_list"
              style={
                this.state.checkedindObj.length > 0
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <ul>
                {this.state.checkedindObj.map((obj) => (
                  <li key={`checkedindObj_${obj.value}`}>
                    {obj.text}
                    <span
                      className="close_icon"
                      onClick={(e) => {
                        e.preventDefault();
                        this.removeCriteriaFromFilter("ind", obj);
                      }}
                    ></span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="choose_company">
            <div
              className="searchBlock"
              onClick={(e) => {
                e.preventDefault();
                this.setState((prev) => ({
                  toggleIndustryDD: false,
                  toggleCompanySizeDD: !prev.toggleCompanySizeDD,
                  toggleViewDD: false,
                  toggleProductDD: false,
                }));
              }}
            >
              <span className="txt">{this.state.captionCompany}</span>
            </div>
            <div
              className="chooseCompanyBlock"
              style={
                !!this.state.toggleCompanySizeDD
                  ? { display: "block" }
                  : { display: "none" }
              }
              onMouseLeave={(e) => {
                if (this._isMounted) {
                  this.setState((prevState) => {
                    return {
                      toggleCompanySizeDD: !prevState.toggleCompanySizeDD,
                    };
                  });
                }
              }}
            >
              <div className="checkbox_control_group">
                {this.props.sizeOptions.map((option, index) => {
                  return (
                    <label
                      key={`size_opt_${index}_${option.value}`}
                      className="checkbox_control control--checkbox"
                    >
                      {option.text}
                      <input
                        type="checkbox"
                        value={option.value}
                        onChange={this.handleChange("size", option)}
                        checked={this.isIndexAvailable("size", option.value)}
                      />
                      <div className="checkboxControlIndicator"></div>
                    </label>
                  );
                })}
              </div>
            </div>
            <div
              className="selected_list"
              style={
                this.state.checkedsizeObj.length > 0
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <ul>
                {this.state.checkedsizeObj.map((obj) => (
                  <li key={`checkedObj_${obj.value}`}>
                    {obj.text}
                    <span
                      className="close_icon"
                      onClick={(e) => {
                        e.preventDefault();
                        this.removeCriteriaFromFilter("size", obj);
                      }}
                    ></span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="filter_view">
            <div
              className="searchBlock"
              onClick={(e) => {
                e.preventDefault();
                this.setState((prev) => ({
                  toggleViewDD: !prev.toggleViewDD,
                  toggleIndustryDD: false,
                  toggleCompanySizeDD: false,
                  toggleProductDD: false,
                }));
              }}
            >
              <span className="txt">{`${this.state.selectedView} per page`}</span>
            </div>
            <div
              className="datalist"
              style={
                !!this.state.toggleViewDD
                  ? { display: "block" }
                  : { display: "none" }
              }
              onMouseLeave={(e) => {
                if (this._isMounted) {
                  this.setState((prevState) => {
                    return {
                      toggleViewDD: !prevState.toggleViewDD,
                    };
                  });
                }
              }}
            >
              <ul>
                <li
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState((prev) => ({
                      selectedView: 15,
                      toggleViewDD: !prev.toggleViewDD,
                    }));
                  }}
                >
                  <a href="#">15</a>
                </li>
                <li
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState((prev) => ({
                      selectedView: 30,
                      toggleViewDD: !prev.toggleViewDD,
                    }));
                  }}
                >
                  <a href="#">30</a>
                </li>
                <li
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState((prev) => ({
                      selectedView: "all",
                      toggleViewDD: !prev.toggleViewDD,
                    }));
                  }}
                >
                  <a href="#">All</a>
                </li>
              </ul>
            </div>
            <div className="selected_list" style={{ display: "block" }}>
              <ul>
                {!!this.state.selectedView && (
                  <li>
                    {this.state.selectedView}
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          selectedView: "",
                        });
                      }}
                      className="close_icon"
                    ></span>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {!!this.props.productOptions &&
            this.props.productOptions.length > 0 && (
              <div className="products">
                <div
                  className="searchBlock"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState((prev) => ({
                      toggleIndustryDD: false,
                      toggleCompanySizeDD: false,
                      toggleViewDD: false,
                      toggleProductDD: !prev.toggleProductDD,
                    }));
                  }}
                >
                  <span className="txt">Choose Product</span>
                </div>
                <div
                  className="productBlock"
                  style={
                    !!this.state.toggleProductDD
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  onMouseLeave={(e) => {
                    if (this._isMounted) {
                      this.setState((prevState) => {
                        return {
                          toggleProductDD: !prevState.toggleProductDD,
                        };
                      });
                    }
                  }}
                >
                  <div className="checkbox_control_group">
                    {this.props.productOptions.map((option, index) => {
                      return (
                        <label
                          key={`product_opt_${index}_${option.value}`}
                          className="checkbox_control control--checkbox"
                        >
                          {option.text}
                          <input
                            type="checkbox"
                            value={option.value}
                            onChange={this.handleChange("product", option)}
                            checked={this.isIndexAvailable(
                              "product",
                              option.value
                            )}
                          />
                          <div className="checkboxControlIndicator"></div>
                        </label>
                      );
                    })}
                  </div>
                </div>
                <div
                  className="selected_list"
                  style={
                    this.state.checkedproductObj.length > 0
                      ? { display: "block" }
                      : { display: "none" }
                  }
                >
                  <ul>
                    {this.state.checkedproductObj.map((obj) => (
                      <li key={`checkedObj_${obj.value}`}>
                        {obj.text}
                        <span
                          className="close_icon"
                          onClick={(e) => {
                            e.preventDefault();
                            this.removeCriteriaFromFilter("product", obj);
                          }}
                        ></span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          <input type="button" value="Filter" onClick={this.applyFilter} />
          <span className="reset" onClick={this.resetFilter}>
            <a href="#">Reset</a>
          </span>
        </div>
        <div className="right">
          <div className="search_box">
            <span
              className="searchIcon"
              onClick={(e) => {
                e.preventDefault();
                this.applyFilter(e);
              }}
            ></span>
            <input
              type="search"
              name=""
              placeholder="Search"
              value={this.state.searchText}
              onChange={(e) => {
                e.persist();
                if (e.target.value.length > 0) {
                  this.setState({
                    searchText: e.target.value,
                  });
                } else {
                  this.setState({
                    searchText: "",
                  });
                }
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  this.applyFilter(e);
                }
              }}
            />
          </div>
        </div>
        {this.state.isLoader && <Loader />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveVendorTestimonialsData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_TESTIMONIAL_DATA,
        payload: data,
      }),
    saveVendorCaseStudiesData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_CASESTUDIES_DATA,
        payload: data,
      }),
    saveVendorVideoData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_VIDEOS_DATA, payload: data }),
    setTestimonialFilterTrue: () =>
      dispatch({
        type: actionTypes.SET_TESTIMONIAL_FILTER_TRUE,
      }),
    setTestimonialFilterFalse: () =>
      dispatch({
        type: actionTypes.SET_TESTIMONIAL_FILTER_FALSE,
      }),
    setCaseStudiesFilterTrue: () =>
      dispatch({
        type: actionTypes.SET_CASESTUDIES_FILTER_TRUE,
      }),
    setCaseStudiesFilterFalse: () =>
      dispatch({
        type: actionTypes.SET_CASESTUDIES_FILTER_FALSE,
      }),
    setVideosFilterTrue: () =>
      dispatch({
        type: actionTypes.SET_VIDEO_FILTER_TRUE,
      }),
    setVideosFilterFalse: () =>
      dispatch({
        type: actionTypes.SET_VIDEO_FILTER_FALSE,
      }),
    setFilterData: (data) => {
      dispatch({
        type: actionTypes.SAVE_VENDOR_TESTIMONIAL_FILTER,
        payload: data,
      });
    },
    resetFilterData: () => {
      dispatch({
        type: actionTypes.SAVE_VENDOR_RESET_FILTER,
      });
    },
  };
};

const WindoSizeFilter = windowSize(VendorFilter);
const VendorFilterWithRouter = withRouter(WindoSizeFilter);

const mapStateToProps = (state) => {
  return {
    vendorProfile: state.vendorProfile,
    vendorTestimonialsReviews: state.vendorTestimonials?.reviews,
    vendorCaseStudiesReviews: state.vendorCaseStudies?.reviews,
    vendorVideosReviews: state.vendorVideos?.reviews,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorFilterWithRouter);
